<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="TaxRuleId"
            v-model="taxRuleId"
            solo
            clearable
            prepend-icon="mdi-magnify"
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="TaxJurisdictionID"
            v-model="taxJurisdictionID"
            solo
            clearable
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Country"
            v-model="countryCode"
            solo
            clearable
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="TaxGroupId"
            v-model="taxGroupId"
            solo
            clearable
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Tax Jurisdiction ID</th>
              <th scope="col">Tax Jurisdiction Code</th>
              <th scope="col">Tax Jurisdiction Name</th>
              <th scope="col">Country</th>
              <th scope="col">Tax Rule ID</th>
              <th scope="col">Tax Group ID</th>
              <th scope="col">Tax Rate</th>
              <th scope="col">Tax Type</th>
              <th scope="col">Tax Sub Type</th>
              <th scope="col">Tax Name</th>
              <th scope="col">Overwrite Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tax in taxesFiltered" :key="tax.id">
              <td>{{ tax.id }}</td>
              <td>{{ tax.taxJurisdictionID }}</td>
              <td>{{ tax.taxJurisdictionCode }}</td>
              <td>{{ tax.taxJurisdictionName }}</td>
              <td>{{ tax.country }}</td>
              <td>{{ tax.taxRuleID }}</td>
              <td>{{ tax.taxGroupID }}</td>
              <td>{{ tax.taxRate }}</td>
              <td>{{ tax.taxType }}</td>
              <td>{{ tax.taxSubType }}</td>
              <td>{{ tax.taxName }}</td>
              <td>{{ tax.overwriteDate }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../../parameters";
import { httpClient } from "../../../requesters/httpClient";

export default {
  name: "TaxesOverwritten",
  data() {
    return {
      taxes: [],
      taxesFiltered: [],
      taxRuleId: "",
      taxGroupId: "",
      countryCode: "",
      taxJurisdictionID: "",
    };
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/taxes-overwritten`)
      .then((response) => {
        this.taxes = response.data;
        this.syncFiltered();
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    syncFiltered() {
      this.taxesFiltered = new Array();
      this.taxes.forEach((tax) => {
        if (
          this.isCountryCode(tax) &&
          this.isTaxJurisdictionId(tax) &&
          this.isTaxRuleIdFiltered(tax) &&
          this.isTaxGroupIdFiltered(tax)
        ) {
          this.taxesFiltered.push(tax);
        }
      });
    },

    isTaxRuleIdFiltered: function (tax) {
      return (
        this.taxRuleId === null ||
        this.taxRuleId === "" ||
        this.taxRuleId === tax.taxRuleID
      );
    },
    isTaxGroupIdFiltered: function (tax) {
      return (
        this.taxGroupId === null ||
        this.taxGroupId === "" ||
        this.taxGroupId === tax.taxGroupID
      );
    },
    isCountryCode: function (tax) {
      return (
        this.countryCode === null ||
        this.countryCode === "" ||
        this.countryCode === tax.country
      );
    },
    isTaxJurisdictionId: function (tax) {
      return (
        this.taxJurisdictionID === null ||
        this.taxJurisdictionID === "" ||
        this.taxJurisdictionID === tax.taxJurisdictionID
      );
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/overwritten/taxes/Taxes.vue